module.exports = __webpack_public_path__ + "static/img/hmx.c7333eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/hmx.png
// module id = Rh3h
// module chunks = 1